// removed by extract-text-webpack-plugin
module.exports = {"droparea":"_27sWlgYsEZzJHNk7OuhMrz","icon":"_18bc_B2AOL8Jvnz_M9RkRn","dragover":"_2Jl8wXTSnBPLUgMHvjLh8L","btns":"_1-h8-gV2H4QTI4cAwv3-bh","msgDefault":"_2nCMshCvc-zadLKcaAHM-_","msgDrop":"_39olquBGBqh2RgvjOki_XO","fileUpload":"_1T-52iQuVMGK2zw0KYvpCL"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/molecules/ImageDropArea-mobile/style.css
// module id = 452
// module chunks = 39